import {createContext} from 'react';

const SearchFormContext = createContext();

const {
    Consumer: SearchFormContextConsumer,
    Provider: SearchFormContextProvider
} = SearchFormContext;

export {
    SearchFormContext,
    SearchFormContextConsumer,
    SearchFormContextProvider
};
